import { Injectable } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { PageCardEnum } from '@shared/enums';
import { AppRoutes } from '@shared/helpers';

@Injectable({ providedIn: 'root' })
export class AppRouterService {
    private readonly previousUrl: Record<PageCardEnum, { url: string; queryParams: Params }> = {
        [PageCardEnum.ORDER_DETAILS]: { url: AppRoutes.routes().DASHBOARD, queryParams: {} },
        [PageCardEnum.ORDER_SETUP]: { url: AppRoutes.routes().DASHBOARD, queryParams: {} },
        [PageCardEnum.RETEST_SETUP]: { url: AppRoutes.routes().DASHBOARD, queryParams: {} },
    };

    constructor(
        private router: Router,
        private route: ActivatedRoute
    ) {}

    getPreviousRoute(pageCard: PageCardEnum): { url: string; queryParams: Params } {
        return this.previousUrl[pageCard];
    }

    logPreviousUrl(pageCards: PageCardEnum[]) {
        pageCards.forEach(pageCard => {
            const currentUrl = this.router.url.indexOf('?') > -1 ? this.router.url.split('?')[0] : this.router.url;
            const currentQueryParams = this.route.snapshot.queryParams;
            this.setPreviousRoute(pageCard, currentUrl, currentQueryParams);
        });
    }

    private setPreviousRoute(pageCard: PageCardEnum, previousUrl: string, queryParams: Params = {}) {
        this.previousUrl[pageCard] = { url: previousUrl, queryParams: queryParams };
    }
}
